import styled, {
  CSSProperties,
  SimpleInterpolation,
  css,
} from "styled-components";
import { TitleProps } from "./index";
import { Keyframe } from "project-config/style";

export const CancelButton = styled.button`
  all: unset;
  background: #5c5d5f;
  border-radius: 4px;
  width: 76px;
  height: 32px;
  font-size: 14px;
  color: #e7eeee;
  text-align: center;
  cursor: pointer;
`;
export const ConfirmButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--main-color);
  border-radius: 4px;
  width: 76px;
  min-width: max-content;
  height: 32px;
  font-size: 14px;
  color: #e7eeee;
  text-align: center;
  cursor: pointer;
  :disabled {
    background: var(--main-color-btn-disable);
    cursor: not-allowed;
  }
  svg {
    margin-left: 3px;
    animation: ${Keyframe.rotate} linear 2.5s infinite;
  }
`;
export const ModalFooter = styled.div<{ cssProperties: CSSProperties }>`
  display: flex;
  position: relative;
  margin: 16px 0;
  justify-content: center;
  ${(p) => p.cssProperties};
`;
export const ModalBody = styled.div<{ width?: string; center?: boolean }>`
  flex: 1;
  padding: 0 16px;
  color: var(--task-eva-toptip);
  font-size: 14px;
  line-height: 20px;
  white-space: pre-wrap;
  word-break: break-word;
  width: ${(p) => p.width};
  ${(p) =>
    p.center &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;
export const BorderTitleWrapper = styled.div<TitleProps>`
  padding: 8px 0 8px 16px;
  border-bottom: 1px solid
    ${(p) => p.titleBorderColor || "var(--task-eva-modal-border)"};
  font-weight: 600;
  font-size: ${(p) => p.titleFontSize || "14px"};
  line-height: 20px;
`;
export const NormalTitleWrapper = styled.div<TitleProps>`
  margin: 20px 0 24px 0;
  padding: 0 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  ${(p) => p.cssProperties};
`;
export const WarningTitleWrapper = styled.div<TitleProps>`
  margin: 20px 0 22px 0;
  padding: 0 16px;
  display: flex;
  align-items: center;
  > svg {
    margin-right: 6px;
  }
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

const getCloseIconPosition = (type: string) => {
  switch (type) {
    case "border-title":
      return css`
        top: 8px;
        right: 16px;
      `;
    default:
      return css`
        top: 20px;
        right: 16px;
      `;
  }
};
export const CloseIconWrapper = styled.div<{
  type: string;
  cssProperties: CSSProperties;
}>`
  position: absolute;
  cursor: pointer;
  ${(p) => getCloseIconPosition(p.type)};
  ${(p) => p.cssProperties};
`;
enum ModalSize {
  Normal = "normal",
  Middle = "middle",
}
const ModalSizeMap = new Map([
  [
    ModalSize.Normal,
    css`
      min-width: 400px;
    `,
  ],
  [
    ModalSize.Middle,
    css`
      width: 600px;
    `,
  ],
]);
export const ModalInnerWrapper = styled.div<{
  size: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  min-height: 190px;
  background: var(--task-eva-modal-bg);
  border: 1px solid var(--task-eva-modal-border);
  border-radius: 4px;
  box-sizing: border-box;
  ${(p) => ModalSizeMap.get(p.size)};
`;
export const ModalWrapper = styled.div<{
  cssProperties: CSSProperties;
  customCSS: SimpleInterpolation;
}>`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(15, 16, 16, 0.7);
  z-index: 2002;
  ${(p) => p.cssProperties};
  ${(p) => p.customCSS};
`;
